import React from 'react';
import { MdChat } from 'react-icons/md';

const ModuleRow = React.memo(({ 
    module, 
    onClickModule, 
    onClickCompareVersion, 
    onClickDiscussion 
}) => {
    return (
        <div className="card-row">
            <div className="card-body" item={module.moduleID} onClick={onClickModule}>
                <div className="col-md-3">
                    {module.cultureTypeID != null ? module.cultureTypeName : module.description}
                </div>
                <div className="col-md-2 last-change-column" style={{ paddingRight: '55px' }}>
                    {module.dateLastChange != null ? module.dateLastChange : ""}
                </div>
                <div className="col-md-2 year-version-column">
                    {module.sentBy}
                </div>
                <div className="col-md-1 year-version-column" style={{ paddingLeft: '35px' }}>
                </div>
                <div className="col-md-2">
                    <div className={
                        module.statusNumber === 0 
                            ? "status notStarted"
                            : ((module.statusNumber === 3 || module.statusNumber === 5 || module.statusNumber === 8 || module.statusNumber === 9) 
                                ? "status rejected"
                                : "status complete")
                    }>
                        {module.status}
                    </div>
                </div>
                <div className="col-md-1">
                    {module.isFinalVersion != null ? (
                        <div className={!module.isFinalVersion ? "status pending" : "status complete"}>
                            {module.isFinalVersion ? "Final" : "Partial"}
                        </div>
                    ) : null}
                </div>
                <div className="col-md-1">
                    {/* <div className={module.percentage === 0 ? "status pending" : "status complete"}>
                        {`${module.percentage}%`}
                    </div> */}
                </div>
            </div>
            <div className="card-row-buttons-body">
                <button 
                    title="Compare Versions" 
                    className="card-row-button version-button" 
                    onClick={onClickCompareVersion}
                >
                    v{module.version}
                </button>
                <button 
                    title="Discussion Dashboard" 
                    className="card-row-button-last" 
                    onClick={onClickDiscussion}
                >
                    <MdChat size={20} />
                </button>
            </div>
        </div>
    );
});

ModuleRow.displayName = 'ModuleRow';

export default ModuleRow;


